import { render, staticRenderFns } from "./VSvg.vue?vue&type=template&id=2d7c38fb&"
import script from "./VSvg.vue?vue&type=script&lang=js&"
export * from "./VSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports